import { Button, Typography } from '@mui/material'
import { SvgAsset, SvgAssetType } from '~/components/SvgAsset'
import { Colors } from '~/libs/mui/theme'

interface VideoActionButtonProps {
  iconType: Extract<SvgAssetType, 'add_playlist' | 'like' | 'share' | 'comment' | 'filmarks'>
  text?: string
  highlight?: boolean
  onClick: () => void
}

export function VideoActionButton({
  iconType,
  text,
  highlight,
  onClick,
}: VideoActionButtonProps): JSX.Element {
  return (
    <Button
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: highlight ? Colors.yellow : Colors.color5A5957,
        gap: '4px',
      }}
      onClick={onClick}
    >
      <SvgAsset
        sx={{
          width: { xs: '25px', sm: '32px' },
          height: { xs: '25px', sm: '32px' },
        }}
        asset={iconType}
      />
      <Typography
        sx={{
          fontSize: { xs: '12px', sm: '14px' },
          height: '21px',
        }}
      >
        {text}
      </Typography>
    </Button>
  )
}
